angular.module('hcap-analytics')
.controller('CsmConsentCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  '$window',
  'UserService',
  function(
    $scope,
    $state,
    $stateParams,
    $window,
    UserService,
  ) {
    const currentYear = moment().year();

    $scope.data = {
      age: null,
      profile: null,
      consentText: null,
      busy: false,
      errorMessage: null,
    };

    UserService.getProfile().then(profile => {
      $scope.data.profile = profile;
      $scope.data.age = profile?.year_of_birth ? Math.max(currentYear - profile.year_of_birth, 0) : null;
    });

    UserService.getConsentText(text => {
      $scope.data.consentText = text;
    });

    $scope.canStartAssessment = function() {
      if (!$scope.data.profile) {
        return false;
      }

      return !!(
        $scope.data.profile.name &&
        $scope.data.profile.email &&
        $scope.data.profile.gender &&
        Number.isInteger(Number($scope.data.age)) &&
        Number($scope.data.age) > 0 &&
        $scope.data.profile.consent
      );
    };

    $scope.startAssessment = function() {
      if (!$scope.canStartAssessment() || $scope.data.busy) {
        return;
      }

      $scope.data.busy = true;
      $scope.data.errorMessage = null;
      $scope.data.profile.year_of_birth = currentYear - Number($scope.data.age);

      UserService.saveProfile($scope.data.profile, user => {
        $scope.data.busy = false;

        if (!user) {
          $scope.data.errorMessage = 'Unable to save your consent selection right now. Please try again.';
          return;
        }

        $window.scrollTo(0, 0);

        if (
          $stateParams.redirectState === 'participate.questions' &&
          $stateParams.redirectParams?.cohortId &&
          $stateParams.redirectParams?.bundleToken
        ) {
          $state.go('csm-bundle', {
            portal: 'CSM',
            cohortId: $stateParams.redirectParams.cohortId,
            token: $stateParams.redirectParams.bundleToken,
          }, { inherit: false });
          return;
        }

        $state.go(
          $stateParams.redirectState || 'dashboard',
          $stateParams.redirectParams || { portal: 'CSM' },
          { inherit: false },
        );
      });
    };
  },
]);
